import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Images } from '../../../assets';
import { Flex } from '../../../components/Flex';
import { AtiraImage } from '../../../components/Image';
import { Text } from '../../../components/Text';
import { Spacing } from '../../../theme/Spacing';

const Container = styled(Flex)`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: ${Spacing.xxxl};
  height: 100%;
  padding-inline: ${Spacing.s};
`;

export const NotificationsUpdatesTab: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Text>{t('bell.drawer.articles_news.description')}</Text>

      <AtiraImage src={Images.AtiraLinkMainLogo} width="70%" />
    </Container>
  );
};
